import {
	Component,
	Input
}                        from '@angular/core';
import { BaseComponent } from '@core/bases/base-component/base.component';
import { SvgStateEnum }  from '@shared/components/svg/svg.model';

// TODO rename to `IndicateTaxationFieldComponent` / `app-indicate-taxation-field`
@Component( {
	selector: 'app-indicate-elster-field',
	templateUrl: './indicate-elster-field.component.html',
	styleUrls: [ './indicate-elster-field.component.scss' ]
} )
export class IndicateElsterFieldComponent extends BaseComponent {

	@Input() indicatesElsterRequiredFormField: boolean;
	@Input() show: boolean;
	@Input() svgStateArray: SvgStateEnum[];

	constructor() { super(); }

}
